import React from 'react';

interface BoxFilterProps {
  title: string;
  tooltip: string;
  count: number;
  color: BoxFilterColor;
  onClick?: () => void;
  selected: boolean;
}

const BoxFilter: React.FC<BoxFilterProps> = ({
  title,
  tooltip,
  count,
  color,
  onClick,
  selected
}) => (
  <div
    className={`box-filter ${color} ${selected ? 'selected' : ''}`}
    title={tooltip}
    onClick={onClick}
  >
    <div className="box-filter__title">
      <span className="box-filter__title-text">{title}</span>
      {tooltip && <i className="fa-light fa-info-circle" title={tooltip}></i>}
    </div>
    <div className="box-filter__count">{count}</div>
  </div>
);

export default BoxFilter;

export enum BoxFilterColor {
  GREEN = 'box-filter__green',
  BLACK = 'box-filter__black',
  ORANGE = 'box-filter__orange',
  TEAL = 'box-filter__teal'
}
